import Slider from "react-slick";
import "./CarouselSlider.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faClock,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";

import { ICategory } from "../../types/backend";
import DateFormat from "../../utils/formatTime/DateFormat";
import { FORMAT_DATE } from "../../utils/constants/timeFormat";
import { useNavigate } from "react-router-dom";

function CarouselSlider({ categories }: any) {
  const navigate = useNavigate();

  // Tạo một đối tượng cho nút "Previous"
  const customPrevArrow = (
    <button type="button" className="custom-slick-arrow">
      <FontAwesomeIcon icon={faChevronLeft} size="1x" />
    </button>
  );

  // Tạo một đối tượng cho nút "Next"
  const customNextArrow = (
    <button type="button" className="custom-slick-arrow">
      <FontAwesomeIcon icon={faChevronRight} size="1x" />
    </button>
  );

  const settings = {
    prevArrow: customPrevArrow, // Sử dụng đối tượng customPrevArrow
    nextArrow: customNextArrow, // Sử dụng đối tượng customNextArrow
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleDetail = (id: any) => {
    navigate(`/category-detail/${id}`);
  };

  return (
    <div className="wrapper-carousel-slider">
      <Slider {...settings}>
        {categories && categories?.length > 0 ? (
          categories.map((item: ICategory, index: number) => {
            return (
              <div className="item" key={index}>
                <div className="item-content">
                  <img src={item.image} alt="no avatar" />
                  <div className="section-content">
                    <h3
                      className="recent-title"
                      onClick={(e) => handleDetail(item?._id)}>
                      <a href="##">{item.name}</a>
                    </h3>
                    <div className="recent-content">
                      <span className="recent-author">
                        <FontAwesomeIcon icon={faPenToSquare} size="1x" />{" "}
                        {item?.updatedBy
                          ? item.updatedBy?.name
                          : item.createdBy?.name}
                      </span>
                      <span className="recent-day">
                        <FontAwesomeIcon icon={faClock} size="1x" />{" "}
                        <DateFormat
                          time={item.createdAt}
                          format={FORMAT_DATE}
                        />
                      </span>
                    </div>
                  </div>
                  <button
                    className="btn-detail"
                    onClick={() => handleDetail(item?._id)}>
                    Xem chi tiết
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}
      </Slider>
    </div>
  );
}

export default CarouselSlider;
